import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { select } from '~/_shared/utils/saga/effects';
import {
  selectLatLngSpreadsheetData, type SpreadsheetLatLngRowData,
} from '~/store/selectors/spreadsheetDataMemoizedSelectors';
import { spreadsheetDataCheckForDeletedRows } from '~/store/spreadsheetData/spreadsheetData.actionTypes';
import { mapSettingsMarkersRemoveMarkersFromPriority } from '../mapSettingsMarkers.actionCreators';
import { mapSettingsMarkersPriorityMarkersSelector } from '../mapSettingsMarkers.selectors';

export function* removeDeletedRowsPriorityMarkersSaga() {
  yield takeLatest(spreadsheetDataCheckForDeletedRows.triggerActions, removeDeletedRowsPriorityMarkers);
}

function* removeDeletedRowsPriorityMarkers() {
  const proceed: boolean = yield call(spreadsheetDataCheckForDeletedRows.conditionSaga);
  if (!proceed) {
    return;
  }

  const priorityMarkers: ReturnType<typeof mapSettingsMarkersPriorityMarkersSelector> = yield select(mapSettingsMarkersPriorityMarkersSelector);
  const spreadsheetData: SpreadsheetLatLngRowData = yield select<SpreadsheetLatLngRowData>(selectLatLngSpreadsheetData);

  const priorityMarkersWithoutRows = priorityMarkers
    .filter(item => !spreadsheetData.getRow(item));

  if (priorityMarkersWithoutRows.length) {
    yield put(mapSettingsMarkersRemoveMarkersFromPriority(priorityMarkersWithoutRows));
  }
}
